import CoterieLogoSVG from '../../assets/img/coterie_logo.svg';
import theme from './';
import { EndorsementOptions as options } from '../../constants';
import silver_icon from '../../icons/Packages/silver.svg';
import gold_icon from '../../icons/Packages/gold.svg';
import platinum_icon from '../../icons/Packages/platinum.svg';
import { ThemeState } from './types';

interface ThemeDetails {
  [key: string]: ThemeState;
}

export const coterieIconSrc = {
  [options.SILVER]: silver_icon,
  [options.GOLD]: gold_icon,
  [options.PLATINUM]: platinum_icon,
};

export const themeDetails: ThemeDetails = {
  coterie: {
    theme,
    logo: {
      imgSrc: CoterieLogoSVG,
      altText: 'Coterie Logo',
      mobileHeight: '24px',
    },
  },
};
